import { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { usePublishedEvents } from '@/hooks/useEvents';

const FALLBACK_ITEMS = [
  { label: '↗ COURSES À VENIR', to: '/explorer' },
  { label: '★ INSCRIPTIONS OUVERTES', to: '/explorer' },
  { label: '↗ TRAILS & ROUTES', to: '/explorer' },
  { label: '★ PARTOUT EN FRANCE', to: '/explorer' },
];

const PREFIXES = ['↗', '★'];

function normalizeTitle(t: string) {
  return t.replace(/\s+/g, ' ').trim().toUpperCase();
}

const BrandStripSection = () => {
  const { data: events = [], isLoading } = usePublishedEvents();

  const items = useMemo(() => {
    const now = Date.now();
    const upcoming = events
      .filter((e: any) => new Date(e.event_date).getTime() > now)
      .slice(0, 12)
      .map((e: any, i: number) => {
        const city = e.city ? normalizeTitle(e.city) : '';
        const title = normalizeTitle(e.title);
        // Format compact : "↗ TITRE" ou "★ TITRE · VILLE" en alternance
        const label = i % 2 === 0
          ? `${PREFIXES[0]} ${title}${city ? ` · ${city}` : ''}`
          : `${PREFIXES[1]} ${title}`;
        return { label, to: `/evenement/${e.slug}` };
      });
    return upcoming.length >= 4 ? upcoming : FALLBACK_ITEMS;
  }, [events]);

  // On duplique pour assurer une boucle continue
  const looped = [...items, ...items, ...items];

  return (
    <section className="border-y border-white/10 overflow-hidden bg-[#080810] py-6" aria-label="Courses à venir">
      <div
        className="flex items-center gap-14 whitespace-nowrap w-max"
        style={{ animation: 'hero-marquee 45s linear infinite' }}
      >
        {looped.map((item, i) => (
          <Link
            key={`${item.to}-${i}`}
            to={item.to}
            className="font-display italic uppercase text-[22px] md:text-2xl tracking-tight -skew-x-6 transition-colors duration-200 hover:text-primary"
            style={{ color: i % 2 === 0 ? 'rgba(255,255,255,0.55)' : 'rgba(255,255,255,0.3)' }}
          >
            {item.label}
          </Link>
        ))}
      </div>
    </section>
  );
};

export default BrandStripSection;
